// extracted by mini-css-extract-plugin
module.exports = {"top-nav":"TopNav_top-nav__DsYbg","bundle-icon":"TopNav_bundle-icon__QKvho","apps":"TopNav_apps__U3oqE","datagraph":"TopNav_datagraph__iGhm1","app-title":"TopNav_app-title__Zuwm1"};